import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import {
  Button,
  Checkbox,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import DataGridComponent from "../../../../components/DataGridComponent";
import Loader from "../../../../components/Loader";
import CreateDisbursement from "./CreateDisbursement";
import UpdateDisbursement from "./UpdateDisbursement";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import AlertComponent from "../../../../components/alert";
import {
  deleteInternalDisbursement,
  getInternalDisbursement,
} from "../../../../thunks/DisPrice";
import { showSnackbar } from "../../../../slice/snackbarSlice";

const InternalDisbursementList = () => {
  const dispatch = useDispatch();
  const [isAddDisbursement, setAddDisbursement] = useState(false);
  const [isUpdateDisbursement, setUpdateDisbursement] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [disbursements, setDisbursements] = useState([]);
  const [isLoader, setLoader] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const inputRef = useRef(null);

  const columns = [
    {
      field: "name",
      headerName: "Name",
      width: 300,
    },
    {
      field: "isActive",
      headerName: "Status",
      width: 240,
      renderCell: (params) => {
        return (
          <div style={{ marginLeft: 70 }}>
            <Checkbox
              sx={{
                color: "#00CE3F",
                "&.Mui-checked": {
                  color: "#00CE3F",
                },
              }}
              checked={params?.row?.isActive ? true : false}
              disabled
            />
          </div>
        );
      },
    },

    {
      field: "Action",
      headerName: "Action",
      width: 100,
      renderCell: (params) => {
        return (
          <>
            <Tooltip title="Update Disbursement">
              <IconButton
                onClick={() => handleClickUpdateDisbursement(params?.row)}
              >
                <EditIcon className="green" />
              </IconButton>
            </Tooltip>

            <Tooltip title="click here to delete disbursement">
              <IconButton>
                <DeleteOutlinedIcon
                  sx={{ color: "#ff0000", textAlign: "center" }}
                  onClick={() => {
                    setShowAlert(true);
                    setSelectedId(params?.row?.id);
                  }}
                >
                  Delete
                </DeleteOutlinedIcon>
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const handleDelete = async () => {
    try {
      setLoader(true);

      const response = await dispatch(
        deleteInternalDisbursement({ id: selectedId || 0 })
      ).unwrap();
      if (response) {
        setDisbursements((prev) =>
          prev.filter((item) => item.id !== selectedId)
        );
      }
      await getDisbursements();
      dispatch(
        showSnackbar({
          show: true,
          message: "Internal disbursement deleted successfully.",
          severity: "success",
        })
      );

      setShowAlert(false);
      setSelectedId("");
      if (inputRef.current) {
        inputRef.current.value = null;
      }
    } catch (error) {
      console.error("Delete failed:", error);
    } finally {
      setLoader(false);
    }
  };

  const getDisbursements = async () => {
    try {
      setLoader(true);
      const response = await dispatch(
        getInternalDisbursement({
          query: {
            isDeleted: false,
          },
        })
      ).unwrap();
      if (response) {
        setDisbursements(response);
      } else {
        setDisbursements([]);
      }
    } catch (error) {
      return error;
    } finally {
      setLoader(false);
    }
  };

  const handleClickUpdateDisbursement = (data) => {
    setSelectedData(data);
    setUpdateDisbursement(true);
  };
  useEffect(() => {
    getDisbursements();
  }, []);
  return (
    <>
      {isLoader && <Loader />}

      <AlertComponent
        open={showAlert}
        handleSuccess={handleDelete}
        handleClose={() => setShowAlert(false)}
        message="Are you sure you want to delete disbursement ?"
      />

      {isAddDisbursement && (
        <CreateDisbursement
          open={isAddDisbursement}
          handleClose={() => setAddDisbursement(false)}
          getDisbursement={getDisbursements}
        />
      )}
      {isUpdateDisbursement && (
        <UpdateDisbursement
          open={isUpdateDisbursement}
          handleClose={() => setUpdateDisbursement(false)}
          selectedData={selectedData}
          getDisbursement={getDisbursements}
        />
      )}
      <Grid container spacing={3} ml={"2px"} width={"98%"}>
        {/* Document Type Section */}
        <Grid item xs={7} mt={1}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              gap: 20,
              alignItems: "center",
              marginBottom: "1rem",
            }}
          >
            <Typography className="serif_display_regular_22 green">
              Internal Disbursements
            </Typography>
            <Button
              className="add_a_new_user_button"
              onClick={() => setAddDisbursement(true)}
            >
              <AddCircleOutlineIcon style={{ paddingRight: 3 }} />
              Add
            </Button>
          </Grid>
          <Grid
            item
            xs={12}
            style={{ width: "100%", height: "80vh", overflow: "auto" }}
          >
            <DataGridComponent
              columns={columns}
              rows={disbursements || []}
              onRowClick={() => {}}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default InternalDisbursementList;
